<template>
  <el-dialog
    v-model="visible"
    title="操作指引"
    width="930"
    class="operate-process-dialog"
    :before-close="handleClose"
  >
    <div class="wrapper">
      <div class="sider">
        <div v-for="item in stepData" :key="item.value" :class="{'sider-item': true, 'sider-active-item': step === item.value}" @click="handleChangeStep(item)">
          <span>0{{item.value}}</span>
          {{item.label}}
        </div>
      </div>
      <div class="content">
        <img :src="currentData.img" />
        <div>
          操作提示：
          <p>{{ currentData.content }}</p>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handlePrev" v-if="step !== stepData[0].value">上一步</el-button>
        <el-button type="primary" @click="handleNext" v-if="step !== stepData[stepData.length - 1].value">下一步</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, ref } from 'vue'
import compareImg1 from '@/assets/images/ipt/compare1.png'

const visible = ref(false)
const step = ref(1)
const stepData = [
  { label: '生成摘要', img: compareImg1, content: '选择需要生成摘要的部分后，点击生成摘要按钮。', value: 1 },
  { label: '前往查新系统', img: compareImg1, content: '可通过点击[一键复制]按钮将生成的摘要复制进剪贴板，也支持进行手动编辑后再进行复制，复制完成后点击[前往查新系统]按钮进入查新系统', value: 2 },
  { label: '检索', img: compareImg1, content: '在查新系统中粘贴摘要后点击[检索]按钮', value: 3 },
  { label: '添加到工作文件', img: compareImg1, content: '在检索结果中选择需要进行比对的专利后，点击[添加到工作文件]', value: 4 },
  { label: '生成报告', img: compareImg1, content: '点击[工作文件]，对需要生成比对文件的专利文件进行选择后，点击[生成报告]按钮', value: 5 },
  { label: '下载报告', img: compareImg1, content: '点击[下载报告]按钮获取到查新报告后，通过浏览器标签页回到交底书撰写系统', value: 6 },
]

const currentData = computed(() => {
  return stepData[step.value - 1]
})

const handleClose = () => {
  visible.value = false
}

const handleOpen = () => {
  step.value = 1
  visible.value = true
}

const handleNext = () => {
  step.value ++
}

const handlePrev = () => {
  step.value --
}

const handleChangeStep = (item) => {
  step.value = item.value
}

defineExpose({ open: handleOpen })
</script>
<style lang="scss" scoped>
.operate-process-dialog {
  .el-dialog__body {
    padding: 16px;
  }
}
.wrapper {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.sider {
  width: 237px;
  padding: 24px;
  background: linear-gradient( 180deg, #EEF8F4 0%, #FFFFFF 100%);
  border-radius: 8px;
  .sider-item {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
    font-size: 16px;
    color: #606060;
    cursor: pointer;
    > span {
      display: block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: var(--el-color-primary);
      border-radius: 5px;
      opacity: 0;
    }
    &.sider-active-item {
      color: var(--el-color-primary);
      > span {
        opacity: 1;
      }
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  > img {
    flex: 1;
    height: 36vh;
    object-fit: contain;
    border-radius: 8px;
  }
  > div {
    min-height: 66px;
    color: #333;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>